// Formato dependiente de idioma (decisiones tomadas: coma/punto, dd/MM/yyyy vs yyyy-MM-dd)
export function fmtNum(n, lang = 'es', dec = 3) {
  if (n === null || n === undefined || n === '') return '—';
  const v = Number(n);
  if (Number.isNaN(v)) return '—';
  const s = v.toLocaleString(lang === 'es' ? 'es-ES' : 'en-GB', {
    minimumFractionDigits: 0, maximumFractionDigits: dec,
  });
  return s;
}

export function fmtInt(n, lang = 'es') {
  return fmtNum(n, lang, 0);
}

export function fmtFecha(iso, lang = 'es') {
  if (!iso) return '—';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '—';
  const dd = String(d.getDate()).padStart(2, '0');
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const yyyy = d.getFullYear();
  return lang === 'es' ? `${dd}/${mm}/${yyyy}` : `${yyyy}-${mm}-${dd}`;
}

export function fmtHora(iso, lang = 'es') {
  if (!iso) return '—';
  const d = new Date(iso);
  const hh = String(d.getHours()).padStart(2, '0');
  const mi = String(d.getMinutes()).padStart(2, '0');
  return `${fmtFecha(iso, lang)} ${hh}:${mi}`;
}
